<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useClinicStore } from '@/stores'
import { ComboboxSelect } from '@/ui'

const clinicsStore = useClinicStore()
const { setClinicById } = clinicsStore
const { clinicsOptions, currentClinic, isFetching, isFetchingClinic } = storeToRefs(clinicsStore)

const clinicId = computed(() => currentClinic.value?.id || 0)
</script>

<template>
  <div v-if="clinicId > 0" class="flex items-center gap-2 px-4">
    <ComboboxSelect
      v-if="clinicsOptions.length > 1"
      :model-value="String(clinicId)"
      :select-options="{ options: clinicsOptions }"
      :is-loading="isFetching || isFetchingClinic"
      class-names="bg-white"
      :max-items="50"
      @handle-change="setClinicById"
    />
    <span v-else class="text-foreground text-sm font-normal">{{ currentClinic?.name }}</span>
  </div>
</template>
